import {
  useDev,
  useAxios,
  AxiosErrorDataModel,
  useDeleteNulls,
} from '@sttedra_ui/framework';

/**
 * @typedef {import("@sttedra_ui/framework").AxiosErrorDataModel} AxiosErrorDataModel
 */

// #region Globals
const CONTEXT_BASE_PATH = 'PDF';
const {base} = useAxios();
// #endregion

// #region Public functions
/**
 * @returns {Object}
 */
async function generatePdf(Guid, params) {
  useDeleteNulls(params);
  const formData = new FormData();
  for (const key of Object.keys(params)) {
    formData.append(key, params[key]);
  }
  try {
    const url = `/${CONTEXT_BASE_PATH}/GetPDF`;

    return await base
      .post(url, formData, {
        'params': {
          Guid,
        },
        'timeout': 50000,
        'responseType': 'blob',
      });
  } catch (err) {
    return catchError(err);
  }
}
/**
 *
 * @param {AxiosErrorDataModel} errorModel
 * @returns
 */
function catchError(errorModel) {
  if (!(errorModel instanceof AxiosErrorDataModel)) {
    throw new Error(errorModel);
  }

  useDev.error(
    errorModel.errors
      .reduce((acc, e) => acc + `(${e.code}) ${e.type}: ${e.message}`,
        `[company.api] Errors:\n`),
  );
}


// #endregion

export {
  generatePdf,
};
